// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrasparenzaRouteImport } from './routes/trasparenza'
import { Route as TerminiCondizioniRouteImport } from './routes/termini-condizioni'
import { Route as ServiziRouteImport } from './routes/servizi'
import { Route as RecensioniRouteImport } from './routes/recensioni'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrezziRouteImport } from './routes/prezzi'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as ContattiRouteImport } from './routes/contatti'
import { Route as ComeFunzionaRouteImport } from './routes/come-funziona'
import { Route as ChiSiamoRouteImport } from './routes/chi-siamo'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoVoltageLuganoRouteImport } from './routes/demo.voltage-lugano'
import { Route as DemoVertexSnowRouteImport } from './routes/demo.vertex-snow'
import { Route as DemoStudioLumiereRouteImport } from './routes/demo.studio-lumiere'
import { Route as DemoOsteriaDelBorgoRouteImport } from './routes/demo.osteria-del-borgo'
import { Route as DemoNordaLivingRouteImport } from './routes/demo.norda-living'
import { Route as DemoMaisonBelleRouteImport } from './routes/demo.maison-belle'
import { Route as DemoHelvetiaCoffeeRouteImport } from './routes/demo.helvetia-coffee'
import { Route as DemoForgeClubRouteImport } from './routes/demo.forge-club'
import { Route as DemoFlashwebUltimateRouteImport } from './routes/demo.flashweb-ultimate'
import { Route as DemoClinicaSalusRouteImport } from './routes/demo.clinica-salus'
import { Route as DemoBianchiPartnersRouteImport } from './routes/demo.bianchi-partners'
import { Route as DemoAuroraJetRouteImport } from './routes/demo.aurora-jet'
import { Route as DemoAlpineEstatesRouteImport } from './routes/demo.alpine-estates'
import { Route as DemoAcquariaLocarnoRouteImport } from './routes/demo.acquaria-locarno'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminProjectsRouteImport } from './routes/admin.projects'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as BlogCategoriaSlugRouteImport } from './routes/blog.categoria.$slug'
import { Route as AdminClientsIdRouteImport } from './routes/admin.clients.$id'
import { Route as AuthenticatedPortalIndexRouteImport } from './routes/_authenticated/portal.index'
import { Route as AuthenticatedPortalUpgradesRouteImport } from './routes/_authenticated/portal.upgrades'
import { Route as AuthenticatedPortalTicketsRouteImport } from './routes/_authenticated/portal.tickets'
import { Route as AuthenticatedPortalSubscriptionRouteImport } from './routes/_authenticated/portal.subscription'
import { Route as AuthenticatedPortalSettingsRouteImport } from './routes/_authenticated/portal.settings'
import { Route as AuthenticatedPortalProjectRouteImport } from './routes/_authenticated/portal.project'
import { Route as AuthenticatedPortalMessagesRouteImport } from './routes/_authenticated/portal.messages'
import { Route as AuthenticatedPortalKnowledgeRouteImport } from './routes/_authenticated/portal.knowledge'
import { Route as AuthenticatedPortalInvoicesRouteImport } from './routes/_authenticated/portal.invoices'
import { Route as AuthenticatedPortalFilesRouteImport } from './routes/_authenticated/portal.files'
import { Route as AuthenticatedPortalDomainsRouteImport } from './routes/_authenticated/portal.domains'
import { Route as AuthenticatedPortalAssistantRouteImport } from './routes/_authenticated/portal.assistant'
import { Route as AuthenticatedPortalAnalyticsRouteImport } from './routes/_authenticated/portal.analytics'
import { Route as AuthenticatedPortalAdminIndexRouteImport } from './routes/_authenticated/portal.admin.index'
import { Route as AuthenticatedPortalAdminTicketsRouteImport } from './routes/_authenticated/portal.admin.tickets'
import { Route as AuthenticatedPortalAdminProjectsRouteImport } from './routes/_authenticated/portal.admin.projects'
import { Route as AuthenticatedPortalAdminBillingRouteImport } from './routes/_authenticated/portal.admin.billing'

const TrasparenzaRoute = TrasparenzaRouteImport.update({
            id: '/trasparenza',path: '/trasparenza',getParentRoute: () => rootRouteImport
          })
const TerminiCondizioniRoute = TerminiCondizioniRouteImport.update({
            id: '/termini-condizioni',path: '/termini-condizioni',getParentRoute: () => rootRouteImport
          })
const ServiziRoute = ServiziRouteImport.update({
            id: '/servizi',path: '/servizi',getParentRoute: () => rootRouteImport
          })
const RecensioniRoute = RecensioniRouteImport.update({
            id: '/recensioni',path: '/recensioni',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PrezziRoute = PrezziRouteImport.update({
            id: '/prezzi',path: '/prezzi',getParentRoute: () => rootRouteImport
          })
const PortfolioRoute = PortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const ContattiRoute = ContattiRouteImport.update({
            id: '/contatti',path: '/contatti',getParentRoute: () => rootRouteImport
          })
const ComeFunzionaRoute = ComeFunzionaRouteImport.update({
            id: '/come-funziona',path: '/come-funziona',getParentRoute: () => rootRouteImport
          })
const ChiSiamoRoute = ChiSiamoRouteImport.update({
            id: '/chi-siamo',path: '/chi-siamo',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DemoVoltageLuganoRoute = DemoVoltageLuganoRouteImport.update({
            id: '/demo/voltage-lugano',path: '/demo/voltage-lugano',getParentRoute: () => rootRouteImport
          })
const DemoVertexSnowRoute = DemoVertexSnowRouteImport.update({
            id: '/demo/vertex-snow',path: '/demo/vertex-snow',getParentRoute: () => rootRouteImport
          })
const DemoStudioLumiereRoute = DemoStudioLumiereRouteImport.update({
            id: '/demo/studio-lumiere',path: '/demo/studio-lumiere',getParentRoute: () => rootRouteImport
          })
const DemoOsteriaDelBorgoRoute = DemoOsteriaDelBorgoRouteImport.update({
            id: '/demo/osteria-del-borgo',path: '/demo/osteria-del-borgo',getParentRoute: () => rootRouteImport
          })
const DemoNordaLivingRoute = DemoNordaLivingRouteImport.update({
            id: '/demo/norda-living',path: '/demo/norda-living',getParentRoute: () => rootRouteImport
          })
const DemoMaisonBelleRoute = DemoMaisonBelleRouteImport.update({
            id: '/demo/maison-belle',path: '/demo/maison-belle',getParentRoute: () => rootRouteImport
          })
const DemoHelvetiaCoffeeRoute = DemoHelvetiaCoffeeRouteImport.update({
            id: '/demo/helvetia-coffee',path: '/demo/helvetia-coffee',getParentRoute: () => rootRouteImport
          })
const DemoForgeClubRoute = DemoForgeClubRouteImport.update({
            id: '/demo/forge-club',path: '/demo/forge-club',getParentRoute: () => rootRouteImport
          })
const DemoFlashwebUltimateRoute = DemoFlashwebUltimateRouteImport.update({
            id: '/demo/flashweb-ultimate',path: '/demo/flashweb-ultimate',getParentRoute: () => rootRouteImport
          })
const DemoClinicaSalusRoute = DemoClinicaSalusRouteImport.update({
            id: '/demo/clinica-salus',path: '/demo/clinica-salus',getParentRoute: () => rootRouteImport
          })
const DemoBianchiPartnersRoute = DemoBianchiPartnersRouteImport.update({
            id: '/demo/bianchi-partners',path: '/demo/bianchi-partners',getParentRoute: () => rootRouteImport
          })
const DemoAuroraJetRoute = DemoAuroraJetRouteImport.update({
            id: '/demo/aurora-jet',path: '/demo/aurora-jet',getParentRoute: () => rootRouteImport
          })
const DemoAlpineEstatesRoute = DemoAlpineEstatesRouteImport.update({
            id: '/demo/alpine-estates',path: '/demo/alpine-estates',getParentRoute: () => rootRouteImport
          })
const DemoAcquariaLocarnoRoute = DemoAcquariaLocarnoRouteImport.update({
            id: '/demo/acquaria-locarno',path: '/demo/acquaria-locarno',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminProjectsRoute = AdminProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AdminRoute
          })
const AdminClientsRoute = AdminClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AdminRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRoute
          })
const BlogCategoriaSlugRoute = BlogCategoriaSlugRouteImport.update({
            id: '/categoria/$slug',path: '/categoria/$slug',getParentRoute: () => BlogRoute
          })
const AdminClientsIdRoute = AdminClientsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminClientsRoute
          })
const AuthenticatedPortalIndexRoute = AuthenticatedPortalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalUpgradesRoute = AuthenticatedPortalUpgradesRouteImport.update({
            id: '/upgrades',path: '/upgrades',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalTicketsRoute = AuthenticatedPortalTicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalSubscriptionRoute = AuthenticatedPortalSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalSettingsRoute = AuthenticatedPortalSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalProjectRoute = AuthenticatedPortalProjectRouteImport.update({
            id: '/project',path: '/project',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalMessagesRoute = AuthenticatedPortalMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalKnowledgeRoute = AuthenticatedPortalKnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalInvoicesRoute = AuthenticatedPortalInvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalFilesRoute = AuthenticatedPortalFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalDomainsRoute = AuthenticatedPortalDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAssistantRoute = AuthenticatedPortalAssistantRouteImport.update({
            id: '/assistant',path: '/assistant',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAnalyticsRoute = AuthenticatedPortalAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAdminIndexRoute = AuthenticatedPortalAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAdminTicketsRoute = AuthenticatedPortalAdminTicketsRouteImport.update({
            id: '/admin/tickets',path: '/admin/tickets',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAdminProjectsRoute = AuthenticatedPortalAdminProjectsRouteImport.update({
            id: '/admin/projects',path: '/admin/projects',getParentRoute: () => AuthenticatedPortalRoute
          })
const AuthenticatedPortalAdminBillingRoute = AuthenticatedPortalAdminBillingRouteImport.update({
            id: '/admin/billing',path: '/admin/billing',getParentRoute: () => AuthenticatedPortalRoute
          })





const AuthenticatedPortalRouteChildren = {
  AuthenticatedPortalAnalyticsRoute: AuthenticatedPortalAnalyticsRoute,AuthenticatedPortalAssistantRoute: AuthenticatedPortalAssistantRoute,AuthenticatedPortalDomainsRoute: AuthenticatedPortalDomainsRoute,AuthenticatedPortalFilesRoute: AuthenticatedPortalFilesRoute,AuthenticatedPortalInvoicesRoute: AuthenticatedPortalInvoicesRoute,AuthenticatedPortalKnowledgeRoute: AuthenticatedPortalKnowledgeRoute,AuthenticatedPortalMessagesRoute: AuthenticatedPortalMessagesRoute,AuthenticatedPortalProjectRoute: AuthenticatedPortalProjectRoute,AuthenticatedPortalSettingsRoute: AuthenticatedPortalSettingsRoute,AuthenticatedPortalSubscriptionRoute: AuthenticatedPortalSubscriptionRoute,AuthenticatedPortalTicketsRoute: AuthenticatedPortalTicketsRoute,AuthenticatedPortalUpgradesRoute: AuthenticatedPortalUpgradesRoute,AuthenticatedPortalIndexRoute: AuthenticatedPortalIndexRoute,AuthenticatedPortalAdminBillingRoute: AuthenticatedPortalAdminBillingRoute,AuthenticatedPortalAdminProjectsRoute: AuthenticatedPortalAdminProjectsRoute,AuthenticatedPortalAdminTicketsRoute: AuthenticatedPortalAdminTicketsRoute,AuthenticatedPortalAdminIndexRoute: AuthenticatedPortalAdminIndexRoute
}

const AuthenticatedPortalRouteWithChildren = AuthenticatedPortalRoute._addFileChildren(AuthenticatedPortalRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedPortalRoute: AuthenticatedPortalRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const AdminClientsRouteChildren = {
  AdminClientsIdRoute: AdminClientsIdRoute
}

const AdminClientsRouteWithChildren = AdminClientsRoute._addFileChildren(AdminClientsRouteChildren)



const AdminRouteChildren = {
  AdminClientsRoute: AdminClientsRouteWithChildren,AdminProjectsRoute: AdminProjectsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogCategoriaSlugRoute: BlogCategoriaSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,ChiSiamoRoute: ChiSiamoRoute,ComeFunzionaRoute: ComeFunzionaRoute,ContattiRoute: ContattiRoute,CookiePolicyRoute: CookiePolicyRoute,FaqRoute: FaqRoute,ImpressumRoute: ImpressumRoute,PortfolioRoute: PortfolioRoute,PrezziRoute: PrezziRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RecensioniRoute: RecensioniRoute,ServiziRoute: ServiziRoute,TerminiCondizioniRoute: TerminiCondizioniRoute,TrasparenzaRoute: TrasparenzaRoute,DemoAcquariaLocarnoRoute: DemoAcquariaLocarnoRoute,DemoAlpineEstatesRoute: DemoAlpineEstatesRoute,DemoAuroraJetRoute: DemoAuroraJetRoute,DemoBianchiPartnersRoute: DemoBianchiPartnersRoute,DemoClinicaSalusRoute: DemoClinicaSalusRoute,DemoFlashwebUltimateRoute: DemoFlashwebUltimateRoute,DemoForgeClubRoute: DemoForgeClubRoute,DemoHelvetiaCoffeeRoute: DemoHelvetiaCoffeeRoute,DemoMaisonBelleRoute: DemoMaisonBelleRoute,DemoNordaLivingRoute: DemoNordaLivingRoute,DemoOsteriaDelBorgoRoute: DemoOsteriaDelBorgoRoute,DemoStudioLumiereRoute: DemoStudioLumiereRoute,DemoVertexSnowRoute: DemoVertexSnowRoute,DemoVoltageLuganoRoute: DemoVoltageLuganoRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)